// --- Mock Data for AuthorProfile ---

export const authorBooks = {
  standalone: [
    {
      id: '1',
      title: 'The Silent Echo',
      author: 'Elena Richards',
      coverImage:
        'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.7,
      formats: ['paperback', 'ebook', 'audiobook'],
      genres: ['Mystery', 'Thriller'],
      isNew: true,
      heatLevel: 3,
      darknessLevel: 4,
      endingType: 'HEA',
      characterRelationships: [
        {
          type: 'Enemies to Lovers',
          style: ['Male & Female (MF)', 'Slow Burn'],
        },
      ],
    },
    {
      id: '2',
      title: 'Whispers in the Dark',
      author: 'Elena Richards',
      coverImage:
        'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.8,
      formats: ['paperback', 'ebook'],
      genres: ['Horror', 'Supernatural'],
      heatLevel: 2,
      darknessLevel: 5,
      endingType: 'Bittersweet',
      characterRelationships: [
        {
          type: 'Forbidden Love',
          style: ['Male & Female (MF)'],
        },
      ],
    },
    // Linked editions example — ONE catalogue listing, not two. The card
    // picks up its "2 Editions" badge and edition links automatically from
    // data/linkedEditions.ts, keyed on this id.
    {
      id: 'ember-and-ash',
      title: 'Ember and Ash',
      author: 'Elena Richards',
      coverImage:
        'https://images.unsplash.com/photo-1490750967868-88aa4486c946?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      rating: 4.6,
      formats: ['paperback', 'ebook', 'audiobook'],
      genres: ['Romance'],
      heatLevel: 3,
      darknessLevel: 2,
      endingType: 'HEA',
      tropes: ['Second Chance', 'Returning Home'],
      characterRelationships: [
        {
          type: 'Second Chance Romance',
          style: ['Male & Female (MF)', 'Slow Burn'],
        },
      ],
    },
  ],
  series: [
    {
      name: 'Echo Series',
      description:
        'A gripping series of interconnected mysteries that follows investigative journalist Mira Hayes as she uncovers the dark secrets of her hometown. Each book peels back another layer of conspiracy and danger.',
      books: [
        {
          id: '3',
          title: 'The Silent Echo',
          author: 'Elena Richards',
          coverImage:
            'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
          rating: 4.7,
          formats: ['paperback', 'ebook', 'audiobook'],
          genres: ['Mystery', 'Thriller'],
          seriesName: 'Echo Series',
          seriesPosition: 1,
          seriesStatus: 'ongoing',
          heatLevel: 3,
          darknessLevel: 4,
          endingType: 'HEA',
          contentWarnings: ['Violence', 'Strong Language'],
          characterRelationships: [
            {
              type: 'Enemies to Lovers',
              style: ['Male & Female (MF)', 'Slow Burn'],
            },
          ],
        },
        {
          id: '4',
          title: 'The Broken Echo',
          author: 'Elena Richards',
          coverImage:
            'https://images.unsplash.com/photo-1633477189729-9290b3261d0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
          rating: 4.9,
          formats: ['paperback', 'ebook', 'audiobook'],
          genres: ['Mystery', 'Thriller'],
          seriesName: 'Echo Series',
          seriesPosition: 2,
          seriesStatus: 'ongoing',
          heatLevel: 4,
          darknessLevel: 4,
          endingType: 'Cliffhanger',
          contentWarnings: ['Violence', 'Strong Language'],
          characterRelationships: [
            {
              type: 'Enemies to Lovers',
              style: ['Male & Female (MF)', 'Slow Burn'],
            },
          ],
        },
      ],
    },
  ],
  collaborations: {
    standalone: [],
    series: [
      {
        name: 'Midnight Mysteries',
        description:
          'A collaborative supernatural mystery series that blends psychological suspense with paranormal elements. Follow two detectives as they investigate cases that bridge the world of the living and the dead.',
        books: [
          {
            id: '5',
            title: 'The Midnight Hour',
            author: 'Elena Richards & Sarah Johnson',
            coverImage:
              'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            rating: 4.6,
            formats: ['paperback', 'ebook'],
            genres: ['Mystery', 'Supernatural'],
            seriesName: 'Midnight Mysteries',
            seriesPosition: 1,
            seriesStatus: 'ongoing',
            heatLevel: 2,
            darknessLevel: 3,
            endingType: 'HEA',
            contentWarnings: ['Violence', 'Paranormal'],
            characterRelationships: [
              {
                type: 'Slow Burn Romance',
                style: ['Male & Female (MF)'],
              },
            ],
          },
        ],
      },
    ],
  },
}
export const audiobooks = [
  {
    id: '1',
    title: 'The Silent Echo',
    coverImage:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    narrator: 'Sarah Johnson',
    duration: '10 hours 23 minutes',
    rating: 4.8,
    genre: 'Mystery',
    spiceLevel: 3,
    tropes: ['Enemies to Lovers', 'Slow Burn'],
    seriesName: 'Echo Series',
    audioSampleUrl: '#',
    platforms: [
      {
        name: 'Audible',
        url: '#',
      },
      {
        name: 'iTunes',
        url: '#',
      },
    ],
  },
  {
    id: '2',
    title: 'The Broken Echo',
    coverImage:
      'https://images.unsplash.com/photo-1633477189729-9290b3261d0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    narrator: 'Sarah Johnson',
    duration: '11 hours 45 minutes',
    rating: 4.9,
    genre: 'Thriller',
    spiceLevel: 4,
    tropes: ['Slow Burn', 'Small Town Secrets'],
    seriesName: 'Echo Series',
    audioSampleUrl: '#',
    platforms: [
      {
        name: 'Audible',
        url: '#',
      },
      {
        name: 'iTunes',
        url: '#',
      },
    ],
  },
]
export const merchandise = [
  {
    id: '1',
    title: 'Silent Echo T-Shirt',
    vendor: 'Literary Apparel Co.',
    image:
      'https://images.unsplash.com/photo-1576566588028-4147f3842f27?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 24.99,
    relatedBook: 'The Silent Echo',
    isOfficialMerch: true,
  },
  {
    id: '2',
    title: 'Echo Series Bookmark Set',
    vendor: 'Page Markers',
    image:
      'https://images.unsplash.com/photo-1544947987-f6c4fa25fa4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    price: 12.99,
    relatedBook: 'The Silent Echo',
    isOfficialMerch: true,
  },
]
export const playlists = [
  {
    id: '1',
    title: 'The Silent Echo - Official Playlist',
    book: 'The Silent Echo',
    platform: 'Spotify',
    image:
      'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    trackCount: 15,
    url: '#',
  },
  {
    id: '2',
    title: 'The Broken Echo - Writing Playlist',
    book: 'The Broken Echo',
    platform: 'Spotify',
    image:
      'https://images.unsplash.com/photo-1633477189729-9290b3261d0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    trackCount: 18,
    url: '#',
  },
]
export const authorData = {
  name: 'Elena Richards',
  slug: 'elena-richards',
  avatar:
    'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
  bio: 'Award-winning author of psychological thrillers and mystery novels. Known for intricate plots and complex female protagonists. Based in Seattle, writing stories that will keep you up all night.',
  location: 'Seattle, WA',
  genres: ['Mystery', 'Thriller', 'Psychological Suspense'],
  rating: 4.8,
  followers: '12.5k',
  booksPublished: 15,
  seriesCount: 3,
  badges: {
    contentType: ['HEA', 'Dark Romance'],
    spiceLevel: 3,
    darknessLevel: 4,
    representation: ['LGBTQ+', 'Diverse Leads'],
    triggers: ['Violence', 'Psychological', 'Dark Themes'],
  },
  social: {
    website: 'https://elenarichards.com',
    newsletter: 'https://elenarichards.com/newsletter',
    instagram: 'elenarichards',
    twitter: 'elenarichards',
    tiktok: 'elenarichards',
  },
  nextRelease: {
    title: 'The Final Echo',
    date: 'October 15, 2023',
    coverImage:
      'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    preorderLink: '#',
  },
  writingInspiration: [
    'Gillian Flynn',
    'Tana French',
    'Stephen King',
    'Ruth Ware',
  ],
  favoriteBooks: [
    'Gone Girl by Gillian Flynn',
    'The Secret History by Donna Tartt',
    'In the Woods by Tana French',
  ],
  favoriteTropes: [
    'Unreliable Narrator',
    'Small Town Secrets',
    'Morally Gray Characters',
    'Found Family',
    'Slow Burn Romance',
  ],
  writingProcess:
    "I write best in the early mornings with a large cup of coffee. My stories usually begin with a character in a difficult situation, and I build the world around them. I'm a plotter who creates detailed outlines before diving into the first draft.",
  funFacts: [
    'I have two rescue cats named after famous detectives',
    'I collect vintage typewriters',
    'I worked as a journalist before becoming a novelist',
    'I write all my first drafts longhand',
  ],
  profileLayout: 'landscape',
  aestheticImages: [
    'https://images.unsplash.com/photo-1519791883288-dc8bd696e667?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    'https://images.unsplash.com/photo-1516414447565-b14be0adf13e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    'https://images.unsplash.com/photo-1518893494013-481c1d8ed3fd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  ],
}
export const seriesConnectionTypes = {
  CONNECTED: 'connected',
  INTERCONNECTED: 'interconnected',
  STANDALONE: 'standalone',
}
export const seriesData = [
  {
    name: 'Echo Series',
    connectionType: seriesConnectionTypes.CONNECTED,
    connectedTo: ['Midnight Mysteries'],
    description: '...',
    genres: ['Mystery', 'Thriller'],
    tropes: ['Small Town Secrets', 'Amateur Detective'],
    contentWarnings: ['Violence', 'Strong Language'],
    characterRelationships: [
      {
        type: 'Enemies to Lovers',
        style: ['Male & Female (MF)', 'Slow Burn'],
      },
    ],
    books: authorBooks.series[0].books,
  },
]
export const events = [
  {
    id: '1',
    name: 'Book Signing: The Silent Echo',
    date: 'October 15, 2023',
    time: '2:00 PM - 4:00 PM',
    location: 'Barnes & Noble, Seattle',
    type: 'Book Signing',
    registrationUrl: '#',
  },
  {
    id: '2',
    name: 'Virtual Author Q&A',
    date: 'October 20, 2023',
    time: '7:00 PM - 8:30 PM',
    location: 'Online (Zoom)',
    type: 'Virtual',
    registrationUrl: '#',
  },
  {
    id: '3',
    name: 'Writing Workshop',
    date: 'November 5, 2023',
    time: '1:00 PM - 3:00 PM',
    location: 'Seattle Public Library',
    type: 'Workshop',
    registrationUrl: '#',
  },
]
export const similarAuthors = [
  {
    id: 'a2',
    name: 'Sarah J. Maas',
    avatar:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200',
    books: 18,
    rating: 4.9,
    genre: 'Fantasy',
  },
  {
    id: 'a3',
    name: 'Colleen Hoover',
    avatar:
      'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=200',
    books: 24,
    rating: 4.8,
    genre: 'Romance',
  },
  {
    id: 'a4',
    name: 'Taylor Jenkins Reid',
    avatar: 'https://images.unsplash.com/photo-1554151228-14d9def656ec?w=200',
    books: 12,
    rating: 4.7,
    genre: 'Fiction',
  },
  {
    id: 'a5',
    name: 'Emily Henry',
    avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200',
    books: 8,
    rating: 4.8,
    genre: 'RomCom',
  },
]
